import { useMemo } from "react";
import useUserRefs from "../../../Hooks/UseUsersQuery/UseUserRefs";
import { UserType } from "../../../Types/userTypes";
import QuickSelectModal, { QuickSelectOption } from "../QuickSelectModal/QuickSelectModal";

export default function SelectUserModal(props: {
    active: boolean,
    onClose: () => void,
    onSelect: (userData: UserType | UserType[]) => void,
    message?: string,
    title?: string,
    multiSelect?: boolean,
    filterFn?: (user: UserType) => boolean
}) {
    const {
        active,
        onClose,
        onSelect,
        message = "Please select a user",
        title = "Choose User",
        multiSelect = false,
        filterFn,
    } = props;

    const userRefs = useUserRefs();

    const options: QuickSelectOption[] = useMemo(() => {
        const seen = new Set<string>()
        return Object.keys(userRefs)
            .filter((key) => {
                const user = userRefs[key]
                if (seen.has(user._id)) return false
                seen.add(user._id)
                if (filterFn && !filterFn(user)) return false
                return true
            })
            .map((key) => {
                const user = userRefs[key]
                return {
                    id: user._id,
                    label: `${user.firstName} ${user.lastName}`,
                    secondaryLabel: user.email,
                }
            })
    }, [userRefs, filterFn])

    const handleSelect = (selected: string | string[]) => {
        if (multiSelect && Array.isArray(selected)) {
            const usersData = selected.map(uid => userRefs[uid])
            onSelect(usersData)
        } else if (typeof selected === 'string') {
            onSelect(userRefs[selected])
        }
        onClose()
    }

    return (
        <QuickSelectModal
            active={active}
            onClose={onClose}
            onSelect={handleSelect}
            options={options}
            title={title}
            message={message}
            multiSelect={multiSelect}
            filterPlaceholder="Filter Users"
        />
    );
}